'use client';

import { Alert, AlertBody, Button, Icon, TextPassage } from '@petsmart-ui/sparky';
import { useRouter } from 'next/navigation';
import { Collapse } from 'transitions-kit';

import { useDecisions } from '@libs/common-next';
import { NAVIGATION_URLS } from '@libs/core';

import { useAutoshipSubscription, useManageSubscriptionAnalytics } from './model';
import './SubscribedWithAutoship.scss';

export const SubscribedWithAutoship = () => {
    const router = useRouter();
    const isSubscribedIndicatorEnabled = useDecisions('x_as_sub_ind');
    const { isReady, nextDeliveryDate, subscriptionOrderId } = useAutoshipSubscription();
    const { send: sendManageSubscription } = useManageSubscriptionAnalytics();

    if (!isSubscribedIndicatorEnabled) return null;

    function handleManageSubscriptionClick() {
        sendManageSubscription();
        const destination = subscriptionOrderId
            ? NAVIGATION_URLS.velocity.account.autoShipOrder(subscriptionOrderId)
            : NAVIGATION_URLS.velocity.account.autoShip;
        router.push(destination);
    }

    return (
        <Collapse in={isReady && !!nextDeliveryDate} mountOnEnter unmountOnExit>
            <Alert variant="info" className="subscribed-autoship" data-testid="subscribed-autoship-indicator">
                <AlertBody className="subscribed-autoship__body">
                    <div className="subscribed-autoship__content">
                        <TextPassage className="subscribed-autoship__title" size="lg">
                            <span>Subscribed with</span>
                            <span className="subscribed-autoship__title-autoship">
                                Autoship
                                <Icon name="autoship-fill" />
                            </span>
                        </TextPassage>
                        {nextDeliveryDate && (
                            <TextPassage
                                className="subscribed-autoship__date"
                                size="lg"
                            >{`Next delivery ${nextDeliveryDate}`}</TextPassage>
                        )}
                    </div>
                    <Button size="lg" text="Manage" onClick={handleManageSubscriptionClick} />
                </AlertBody>
            </Alert>
        </Collapse>
    );
};
